module.exports = __webpack_public_path__ + "img/hide-icon-arrow-blue.a62dd163.svg";